<template>
  <div class="feedback">
    <div class="feedback-table" ref="scrollBox">
      <a-table
        bordered
        :dataSource="tableData"
        :columns="columns"
        rowKey="id"
        :pagination="false"
        :scroll="{ y: 'calc( 100vh - 520px )' }"
      >
        <template #title>
          <div class="df both-side vertical">
            <h2>{{ props.customText }}</h2>
            <button @click="handleUpdateFeedback(null)">新增</button>
          </div>

          <!-- <a-button
            slot="customButton"
            type="primary"
            @click="handleUpdateFeedback(null)"
            >新增{{ props.customText }}</a-button
          > -->
        </template>

        <template #customRender="{ index }">
          {{
            requestPayload.pageNum > 1
              ? index + 1 + (requestPayload.pageNum - 1) * 10
              : index + 1
          }}
        </template>

        <template #imgList="{ record }">
          <template v-if="record.image">
            <a-image-preview-group>
              <a-image
                v-for="url in record.image"
                :key="url"
                :width="50"
                :src="url"
              />
            </a-image-preview-group>
          </template>
        </template>

        <template #action="{ record }">
          <a-button
            size="small"
            @click="handleUpdateFeedback(record)"
            v-if="record.userId == store.state.user.user.id"
            >编辑</a-button
          >
        </template>
      </a-table>
    </div>

    <div class="pagination df both-side">
      <a-pagination
        v-model:current="requestPayload.pageNum"
        v-model:pageSize="requestPayload.lineNum"
        :total="requestPayload.total"
        :show-total="(total) => `共 ${total} 条`"
        @change="handlePageChange"
        @showSizeChange="handleSizeChange"
        size="small"
      />
    </div>
  </div>

  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="600"
  >
    <a-form :label-col="{ span: 4 }" labelAlign="left">
      <a-form-item label="内容">
        <a-textarea
          v-model:value="feedback"
          auto-size
          placeholder="请输入内容"
        />
      </a-form-item>

      <a-form-item label="上传图片">
        <upload @setUploadFileUrl="setUploadFileUrl"></upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import { debounce, Toast } from "@/utils";
import {
  getFeedbackList,
  saveOrUpdateFeedback,
} from "@/request/view/qualityInspection";
import upload from "@/views/rdmanagement/components/projectAnnouncement/upload.vue";

export default defineComponent({
  props: {
    feedbackType: String,
    customText: String,
  },
  components: { upload },
  setup(props, context) {
    const store = useStore();
    const requestPayload = reactive({
      lineNum: 10,
      pageNum: 1,
      total: 0,
    });

    const tableData = reactive([]);

    const columns = reactive([
      {
        title: "序号",
        dataIndex: "id",
        width: "80px",
        align: "center",
        slots: { customRender: "customRender" },
      },
      {
        title: props.customText,
        dataIndex: "feedback",
        align: "center",
      },
      {
        title: "图片",
        align: "center",
        slots: { customRender: "imgList" },
      },
      // { title: "用户", dataIndex: "username", width: 80, align: "center" },
      {
        title: "时间",
        dataIndex: "createTime",
        width: "180px",
        align: "center",
      },
      // {
      //   title: "操作",
      //   slots: { customRender: "action" },
      //   width: 80,
      //   align: "center",
      // },
    ]);

    const modalConfig = reactive({
      title: props.customText,
      visible: false,
    });

    const feedback = ref(null);

    const fileList = ref([]);

    let echoId = null;

    const setUploadFileUrl = (list) => {
      fileList.value.length = 0;
      list.value.forEach((file) => {
        fileList.value.push(file.url);
      });
    };

    const handleUpdateFeedback = (data) => {
      if (!data) {
        modalConfig.visible = true;
        feedback.value = null;
      } else {
        modalConfig.visible = true;
        feedback.value = data.feedback;
        echoId = data.id;
      }
    };

    const handleCancel = () => {
      modalConfig.visible = false;
      feedback.value = null;
      echoId = null;
    };

    const getTableData = debounce(() => {
      tableData.length = 0;
      getFeedbackList({
        lineNum: requestPayload.lineNum,
        pageNum: requestPayload.pageNum,
        type: props.feedbackType,
      })
        .then((res) => {
          if (res.code === 200 && res.message === "成功") {
            res.data.records.forEach((item) => {
              if (item.image) {
                item.image = JSON.parse(item.image);
              }
            });
            tableData.push(...res.data.records);
            requestPayload.total = res.data.total;
            // getTableScroll();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }, 200);

    const handleOk = debounce(() => {
      const { id, username } = store.state.user.user;
      saveOrUpdateFeedback({
        type: props.feedbackType,
        feedback: feedback.value,
        image: JSON.stringify(fileList.value),
        userId: id,
        username,
        id: echoId,
      })
        .then((res) => {
          fileList.value.length = 0;
          let type = res.code === 200 ? "success" : "warning";
          Toast(type, res.message, 3);
          handleCancel();
          getTableData();
        })
        .catch((err) => {});
    }, 200);

    const handlePageChange = (page) => {
      requestPayload.pageNum = page;
      getTableData();
    };

    const scrollBox = ref();
    const tableSroll = reactive({
      x: null,
      y: null,
    });

    // const getTableScroll = () => {
    //   nextTick(() => {
    //     if (scrollBox.value) {
    //       const domInfo = scrollBox.value.getBoundingClientRect();
    //       tableSroll.y = domInfo.height - 100;
    //     }
    //     console.log(tableSroll);
    //   });
    // };

    // window.addEventListener("resize", getTableScroll);

    const handleSizeChange = (page, pageSize) => {
      console.log(page, pageSize);
    };

    watch(
      () => props.feedbackType,
      (val) => {
        if (val) {
          // columns[1].title = val;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      store,
      props,
      setUploadFileUrl,
      requestPayload,
      tableData,
      columns,
      modalConfig,
      feedback,
      handleUpdateFeedback,
      handleOk,
      handleCancel,
      handlePageChange,
      scrollBox,
      tableSroll,
      handleSizeChange,
    };
  },
});
</script>

<style lang="less" scoped>
button {
  background: #35b7ad;
  color: #fff;
  padding: 0 7px;
  font-size: 14px;
  border-radius: 4px;
  line-height: 1.5715;
  height: 24px;
  letter-spacing: 2px;
}
.feedback {
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
}
.feedback-table {
  width: calc((100vw - 320px) / 2);
  height: calc(100vh - 380px);
}
</style>
